<div class="input-wrapper" pcLabelUpInputAnimation [alwaysTop]="staticLabel()">
  <div
    #inputBorder
    #trigger="cdkOverlayOrigin"
    class="input-border"
    cdkOverlayOrigin
    [ngClass]="{ required: InputError && InputError.error }"
  >
    <label
      #labelUpDirective
      class="input-label {{ displayIconWithCustomText() && isSelect() && !ignoreImage() ? 'margin-inline-start' : '' }}"
      [class.static]="staticLabel()"
      [for]="cid"
      [ngClass]="{
        disabled: isDisabled(),
        'mandatory-before': isMandatory() && asteriskPosition() === 'before',
        'mandatory-after': isMandatory() && asteriskPosition() === 'after'
      }"
    >
      {{ label() || null }}
    </label>
    <div class="input-and-icon">
      @if (!ignoreImage() && displayIconWithCustomText() && this.isSelect()) {
        <img class="svg-image" src="{{ selectedImage() }}" alt="{{ inputValue() }}" />
      }
      <input
        #inputElement
        class="pc-input {{ displayIconWithCustomText() && isSelect() ? 'margin-top' : '' }}"
        type="text"
        role="combobox"
        aria-autocomplete="list"
        [attr.aria-activedescendant]="ariaActiveDescendant()"
        [attr.aria-controls]="dropdownPanelId"
        [attr.aria-expanded]="isPanelOpen()"
        [disabled]="isDisabled() || isLoading()"
        [id]="cid"
        [name]="name()"
        [placeholder]="placeholder()"
        [tabIndex]="tabIndex()"
        (blur)="onInputBlur()"
        (focus)="onInputFocus()"
        (input)="filterOptions(inputValue())"
        (keyup)="onInputKeyUp($event)"
        [(ngModel)]="inputValue"
      />
      @if (isLoading()) {
        <pc-spinning-loader class="display-icon" [isPrimaryColor]="true"></pc-spinning-loader>
      } @else if (displayChevronIcon()) {
        @if (isPanelOpen()) {
          <img
            class="display-icon pointer"
            src="{{ PcButtonIcon.UP_CHEVRON }}"
            alt=""
            tabindex="-1"
            (click)="closeList()"
            (keyup.enter)="closeList()"
          />
        } @else {
          <img
            class="display-icon pointer"
            src="{{ PcButtonIcon.DOWN_CHEVRON }}"
            alt=""
            tabindex="-1"
            (click)="openList()"
            (keyup.enter)="openList()"
          />
        }
      }
    </div>
  </div>

  <ng-template
    #overlayRef
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isPanelOpen()"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayWidth]="inputBorder.offsetWidth"
    [pcCdkOverlayDynamicOffsetY]="7"
    (overlayKeydown)="onOverlayKeydown($event)"
    (overlayOutsideClick)="clearFormAndClose()"
  >
    <div #dropdownPanel class="drop-down-panel {{ relevant() ? 'relevant' : '' }}">
      <ul class="checkbox-list" role="listbox" [attr.aria-label]="label()" [id]="dropdownPanelId">
        <cdk-virtual-scroll-viewport
          [itemSize]="optionLineHeight"
          [style.height.px]="viewportHeight()"
          [style.overflow]="useSingleItemFound() ? (singleItemFound() ? 'hidden' : 'auto') : 'auto'"
        >
          <li
            *cdkVirtualFor="let option of filteredOptions(); index as index; trackBy: trackByFn; last as last"
            class="checkbox-item"
            role="option"
            [attr.aria-selected]="option.value === this.value"
            [id]="dropdownOptionIdPrefix + index"
            [ngClass]="{ isLast: last, highlighted: index === activeIndex()() }"
            [tabindex]="-1"
            (click)="selectOption(option)"
            (keyup.enter)="selectOption(option)"
            (keyup.space)="selectOption(option)"
          >
            @if (option.image?.length) {
              <div class="option-container">
                <img class="svg-image" src="{{ option.image }}" alt="{{ option.text }}" />
                <div class="option-text">
                  {{ option.text }}
                </div>
              </div>
            } @else {
              {{ option.text }}
            }
          </li>
        </cdk-virtual-scroll-viewport>
        @if (!filteredOptions().length) {
          <li class="checkbox-item isLast">{{ noResultsText() }}</li>
        }
      </ul>
    </div>
  </ng-template>

  <span
    class="error-text"
    aria-atomic="true"
    aria-live="assertive"
    [attr.role]="InputError?.error && isInputFocus ? 'alert' : null"
    [class.ltr-inline]="businessUnit() === BusinessUnit.AU"
  >
    {{ InputError?.error ?? '' | translate }}
  </span>
</div>
